'use strict'
const Base = require('../base.edit')
const modal = new (require('../../helpers/modal'))
const forms = new (require('../../helpers/forms'))

module.exports = class regFormZOSR extends Base {

onInit() {

		let button = document.createElement('button')
		button.className = 'formater'
		button.onclick = this.formTags.bind(this)
		this.btnTags = button
		this.btnText()
		this._elemButtons.appendChild(button)

	}

	onDestroy() {}

	btnText() {
		if (!this._data.tags) { this._data.tags = [] }
		this.btnTags.innerHTML = '<i class="material-icons">build</i> &nbsp; ' +
			this._data.tags.join(',')
	}

	formTags() {

		let block = document.createElement('div')
		block.className = 'form-block'
		let wrapper = document.createElement('div')
		wrapper.className = 'form-wrapper'
		let div = document.createElement('div')
		div.className = 'form-group'


		let status = document.createElement('select')

		status.innerHTML = `
			<option>S galavečerom</option>
			<option>Bez galavečera</option>
		`

		div.appendChild(forms.input('Typ widgetu', status))


		wrapper.appendChild(div)
		block.appendChild(wrapper)

		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Odoslať'
		button.onclick = () => {
			this._data.status = status.value

			this._render()
			modal.hide()
			this.btnText()
		}
		block.appendChild(forms.actions(button))

		let title = 'Nastavenia'
		modal.show(title, block).then(() => { text.focus() })

	}


}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/registration-form-zosr/registration-form-zosr.edit.js
// module id = 489
// module chunks = 0